import React from "react";

const mapMladojenec = `<div style="width: 100%"><iframe width="520" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=520&amp;height=320&amp;hl=en&amp;q=Povelyanovo,%20%D1%83%D0%BB.%20%D0%A0%D0%B8%D0%B1%D0%B0%D1%80%D1%81%D0%BA%D0%B0%201+(%D0%9A%D1%8A%D1%89%D0%B0%D1%82%D0%B0%20%D0%BD%D0%B0%20%D0%9C%D0%BB%D0%B0%D0%B4%D0%BE%D0%B6%D0%B5%D0%BD%D0%B5%D1%86%D0%B0)&amp;t=&amp;z=16&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">Bevölkerung visualisieren Karte</a></iframe></div>`;
const mapMladojenecMobile = `<div style="width: 100%"><iframe width="310" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=310&amp;height=320&amp;hl=en&amp;q=Povelyanovo,%20%D1%83%D0%BB.%20%D0%A0%D0%B8%D0%B1%D0%B0%D1%80%D1%81%D0%BA%D0%B0%201+(%D0%9A%D1%8A%D1%89%D0%B0%D1%82%D0%B0%20%D0%BD%D0%B0%20%D0%9C%D0%BB%D0%B0%D0%B4%D0%BE%D0%B6%D0%B5%D0%BD%D0%B5%D1%86%D0%B0)&amp;t=&amp;z=16&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">Bevölkerungskarte Deutschland</a></iframe></div>`;

const mapKumove = `<div style="width: 100%"><iframe width="520" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=520&amp;height=320&amp;hl=en&amp;q=Povelyanovo,%20%D0%92%D0%B5%D0%BB%D0%B8%D0%BA%D0%BE%20%D0%A2%D1%8A%D1%80%D0%BD%D0%BE%D0%B2%D0%BE%208+(%D0%9A%D1%8A%D1%89%D0%B0%D1%82%D0%B0%20%D0%BD%D0%B0%20%D0%9A%D1%83%D0%BC%D0%BE%D0%B2%D0%B5%D1%82%D0%B5)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">Demografie Karte Deutschland</a></iframe></div>`;
const mapKumoveMobile = `<div style="width: 100%"><iframe width="310" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=310&amp;height=320&amp;hl=en&amp;q=Povelyanovo,%20%D0%92%D0%B5%D0%BB%D0%B8%D0%BA%D0%BE%20%D0%A2%D1%8A%D1%80%D0%BD%D0%BE%D0%B2%D0%BE%208+(%D0%9A%D1%8A%D1%89%D0%B0%D1%82%D0%B0%20%D0%BD%D0%B0%20%D0%9A%D1%83%D0%BC%D0%BE%D0%B2%D0%B5%D1%82%D0%B5)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">Kartentool Bevölkerung</a></iframe></div>`;

const mapBulka = `<div style="width: 100%"><iframe width="520" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=520&amp;height=320&amp;hl=en&amp;q=%D1%83%D0%BB.%20%D0%A5%D1%80%D0%B8%D1%81%D1%82%D0%BE%20%D0%9F%D0%B0%D1%82%D1%80%D0%B5%D0%B2%201,%209250%20Dalgopol+(%D0%9A%D1%8A%D1%89%D0%B0%D1%82%D0%B0%20%D0%BD%D0%B0%20%D0%91%D1%83%D0%BB%D0%BA%D0%B0%D1%82%D0%B0)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">interaktive Bevölkerungskarte</a></iframe></div>`;
const mapBulkaMobile = `<div style="width: 100%"><iframe width="310" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=310&amp;height=320&amp;hl=en&amp;q=%D1%83%D0%BB.%20%D0%A5%D1%80%D0%B8%D1%81%D1%82%D0%BE%20%D0%9F%D0%B0%D1%82%D1%80%D0%B5%D0%B2%201,%209250%20Dalgopol+(%D0%9A%D1%8A%D1%89%D0%B0%D1%82%D0%B0%20%D0%BD%D0%B0%20%D0%91%D1%83%D0%BB%D0%BA%D0%B0%D1%82%D0%B0)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">Kartentool Bevölkerung</a></iframe></div>`;

const mapRestorant = `<div style="width: 100%"><iframe width="520" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=520&amp;height=320&amp;hl=en&amp;q=Hotel%20Ovech,%209260%20Asparuhovo+(%D0%A5%D0%BE%D1%82%D0%B5%D0%BB%20%D0%9E%D0%B2%D0%B5%D1%87)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">Bevölkerung visualisieren Karte</a></iframe></div>`;
const mapRestorantMobile =`<div style="width: 100%"><iframe width="310" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=310&amp;height=320&amp;hl=en&amp;q=Hotel%20Ovech,%209260%20Asparuhovo+(%D0%A5%D0%BE%D1%82%D0%B5%D0%BB%20%D0%9E%D0%B2%D0%B5%D1%87)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">interaktive Bevölkerungskarte</a></iframe></div>`;

const mapCurkva = `<div style="width: 100%"><iframe width="520" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=520&amp;height=320&amp;hl=en&amp;q=%D0%A6%D1%8A%D1%80%D0%BA%D0%B2%D0%B0%20%D0%A1%D0%B2%D0%B5%D1%82%D0%B0%20%D0%9F%D0%B5%D1%82%D0%BA%D0%B0,%20%D1%81.%20%D0%90%D1%81%D0%BF%D0%B0%D1%80%D1%83%D1%85%D0%BE%D0%B2%D0%BE,%20+(%D0%A6%D1%8A%D1%80%D0%BA%D0%B2%D0%B0%20%22%D0%A1%D0%B2%D0%B5%D1%82%D0%B0%20%D0%9F%D0%B5%D1%82%D0%BA%D0%B0%22)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">Demografie Karte Deutschland</a></iframe></div>`;
const mapCurkvaMobile = `<div style="width: 100%"><iframe width="310" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=310&amp;height=320&amp;hl=en&amp;q=%D0%A6%D1%8A%D1%80%D0%BA%D0%B2%D0%B0%20%D0%A1%D0%B2%D0%B5%D1%82%D0%B0%20%D0%9F%D0%B5%D1%82%D0%BA%D0%B0,%20%D1%81.%20%D0%90%D1%81%D0%BF%D0%B0%D1%80%D1%83%D1%85%D0%BE%D0%B2%D0%BE,%20+(%D0%A6%D1%8A%D1%80%D0%BA%D0%B2%D0%B0%20%22%D0%A1%D0%B2%D0%B5%D1%82%D0%B0%20%D0%9F%D0%B5%D1%82%D0%BA%D0%B0%22)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">Bevölkerungskarte Deutschland</a></iframe></div>`;

export default function Transport() {
  //TODO
  const isMobile = window && window.innerWidth < 600;
  return (
    <div className="p-top-12 p-bottom-8 transport bg-white" id="transport">
      <div className="container p-top-8">
        <h1 className="text-center m-bottom-4">Как да стигна?</h1>
        <div className="flex flex-justify-center">
          <div className="col-12 col-8-xl text-center">
            <p className="text-md m-bottom-2">
              Тук може да намерите GPS координатите на всички места от Сватбата.
            </p>
            <p className="text-md m-bottom-2">
              Комплекс Овеч се намира в с.Аспарухово, на 15 км от гр. Дългопол, на 35 км. от гр. Провадия и на 75 км. от гр. Варна и гр. Бургас.
            </p>
          </div>
        </div>
        <div className="flex flex-justify-center m-top-8">
          <div className="col-12 col-6-xl">
            <h4 className="text-center">Почивен комплекс “Овеч”</h4>
            <h6 className="text-center m-bottom-1">с. Аспарухово</h6>
            <p className="text-xs text-center">(Цъкни върху "Directions")</p>
            <div className="flex flex-justify-center m-top-1 m-bottom-5">
              {!isMobile && (
                <div
                  className="map-location hidden-xs hidde-sm shadow-default"
                  dangerouslySetInnerHTML={{ __html: mapRestorant }}
                />
              )}
              {isMobile && (
                <div
                  className="map-location hidden-md hidden-lg hidden-xl shadow-default"
                  dangerouslySetInnerHTML={{ __html: mapRestorantMobile }}
                />
              )}
            </div>
          </div>
          <div className="col-12 col-6-xl">
            <h4 className="text-center">Църква "Света Петка"</h4>
            <h6 className="text-center m-bottom-1">с. Аспарухово</h6>
            <p className="text-xs text-center">(Цъкни върху "Directions")</p>
            <div className="flex flex-justify-center m-top-1 m-bottom-5">
              {!isMobile && (
                <div
                  className="map-location hidden-xs hidde-sm shadow-default"
                  dangerouslySetInnerHTML={{ __html: mapCurkva }}
                />
              )}
              {isMobile && (
                <div
                  className="map-location hidden-md hidden-lg hidden-xl shadow-default"
                  dangerouslySetInnerHTML={{
                    __html: mapCurkvaMobile,
                  }}
                />
              )}
            </div>
          </div>

          <div className="col-12 col-6-xl">
            <h4 className="text-center">Къща на Булката</h4>
            <h6 className="text-center m-bottom-1">гр. Дългопол</h6>
            <p className="text-xs text-center">(Цъкни върху "Directions")</p>
            <div className="flex flex-justify-center m-top-1 m-bottom-5">
              {!isMobile && (
                <div
                  className="map-location hidden-xs hidde-sm shadow-default"
                  dangerouslySetInnerHTML={{ __html: mapBulka }}
                />
              )}
              {isMobile && (
                <div
                  className="map-location hidden-md hidden-lg hidden-xl shadow-default"
                  dangerouslySetInnerHTML={{
                    __html: mapBulkaMobile,
                  }}
                />
              )}
            </div>
          </div>
          <div className="col-12 col-6-xl">
            <h4 className="text-center">Къща на Младоженеца</h4>
            <h6 className="text-center m-bottom-1">кв. Повеляново, гр. Девня</h6>
            <p className="text-xs text-center">(Цъкни върху "Directions")</p>
            <div className="flex flex-justify-center m-top-1 m-bottom-5">
              {!isMobile && (
                <div
                  className="map-location hidden-xs hidde-sm shadow-default"
                  dangerouslySetInnerHTML={{ __html: mapMladojenec }}
                />
              )}
              {isMobile && (
                <div
                  className="map-location hidden-md hidden-lg hidden-xl shadow-default"
                  dangerouslySetInnerHTML={{
                    __html: mapMladojenecMobile,
                  }}
                />
              )}
            </div>
          </div>
          <div className="col-12 col-6-xl">
            <h4 className="text-center">Къща на Кумовете</h4>
            <h6 className="text-center m-bottom-1">кв. Повеляново, гр. Девня</h6>
            <p className="text-xs text-center">(Цъкни върху "Directions")</p>
            <div className="flex flex-justify-center m-top-1 m-bottom-5">
              {!isMobile && (
                <div
                  className="map-location hidden-xs hidde-sm shadow-default"
                  dangerouslySetInnerHTML={{ __html: mapKumove }}
                />
              )}
              {isMobile && (
                <div
                  className="map-location hidden-md hidden-lg hidden-xl shadow-default"
                  dangerouslySetInnerHTML={{
                    __html: mapKumoveMobile,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
